$(document).ready(function(){


    /*
     * Collections Add / delete items
     */

    /*if ($(".custom-collection-row").length) {

        function addItem(addButton) {
            var containerSelector = addButton.dataset.container;
            var container = document.querySelector(containerSelector);
            var prototype = container.dataset.prototype;

            var index = container.querySelectorAll('.custom-collection-row-entry').length;

            var newItem = prototype.replace(/__name__/g, index);

            // Create a wrapper element for the new item
            var itemWrapper = document.createElement('div');
            itemWrapper.classList.add('custom-collection-row-entry');
            itemWrapper.innerHTML = newItem;

            container.appendChild(itemWrapper);

            var addItemButtons = itemWrapper.getElementsByClassName('add-item');
            for (var i = 0; i < addItemButtons.length; i++) {
                addItemButtons[i].addEventListener('click', function() {
                    addItem(this);
                });
            }


            var deleteButtons = container.querySelectorAll('.delete-button');
            var newDeleteButton = deleteButtons[deleteButtons.length - 1];
            newDeleteButton.addEventListener('click', function() {
                deleteItem(this);
            });
        }

        function deleteItem(deleteButton) {

            var item = deleteButton.parentNode.closest('.custom-collection-row-entry');
            item.parentNode.removeChild(item);
        }

        var addButtons = document.getElementsByClassName('add-item');
        for (var i = 0; i < addButtons.length; i++) {
            addButtons[i].addEventListener('click', function() {
                addItem(this);
            });
        }

        var deleteButtons = document.getElementsByClassName('delete-button');
        for (var i = 0; i < deleteButtons.length; i++) {
            deleteButtons[i].addEventListener('click', function() {
                deleteItem(this);
            });
        }
    }*/

    /*if ($('.white-popup-auto-close').length) {
        $('.white-popup-auto-close').each(function(i, obj) {
            setTimeout(function(){
                $(obj).addClass('is-hidden');
                $(obj).remove();
            }, 3000);
        });
    }*/

    if ($('.notification-auto-close').length) {
        $('.notification-auto-close .delete').on('click', function(){
            $(this).closest('.notification-auto-close').addClass('is-hidden');
            $(this).closest('.notification-auto-close').remove();
        });
        $('.notification-auto-close').each(function(i, obj) {
            setTimeout(function(){
                $(obj).addClass('is-hidden');
                $(obj).remove();
            }, 3000);
        });
    }


    if ($('#solicitude_step2_form_project_keywords').length && $('#solicitude_step2_form_project_keywordComment').length) {
        let checked = false;
        $('#solicitude_step2_form_project_keywords input[data-comment="1"]').each(function(){
            if ($(this).is(':checked')) {
                checked = true;
            }
        });
        $('#solicitude_step2_form_project_keywordComment').closest('div.column').toggle(checked);
        $('#solicitude_step2_form_project_keywords input[data-comment="1"]').on('change', function(){
            let checked = false;
            $('#solicitude_step2_form_project_keywords input[data-comment="1"]').each(function(){
                if ($(this).is(':checked')) {
                    checked = true;
                }
            });
            $('#solicitude_step2_form_project_keywordComment').closest('div.column').toggle(checked);
        });
    }
    
    if ($('#project_update_funding_period_form_durationApproved').length
        && $('#project_update_funding_period_form_fundingStart').length
        && $('#project_update_funding_period_form_fundingEnd').length
    ) {
		function updateFundingPeriodEnd()
		{
			const durationMonth = parseInt($('#project_update_funding_period_form_durationApproved').val(), 10);
			const startDate = $('#project_update_funding_period_form_fundingStart').val();
			if (durationMonth != '' && startDate !='' ) {
				let date = new Date(startDate);
				date.setMonth(date.getMonth()+durationMonth);
				date.setDate(date.getDate()-1);
				$('#project_update_funding_period_form_fundingEnd').val(date.toISOString().substring(0,10));
			}
		}
		$('#project_update_funding_period_form_durationApproved').on('change', updateFundingPeriodEnd);
		$('#project_update_funding_period_form_fundingStart').on('change', updateFundingPeriodEnd);
	}

    if ($('#project_update_prolongation_period_form_prolongationMonths').length
        && $('#project_update_prolongation_period_form_prolongationStart').length
        && $('#project_update_prolongation_period_form_prolongationEnd').length
    ) {
        function updateProlongationPeriodEnd()
        {
            const months = Number($('#project_update_prolongation_period_form_prolongationMonths').val());
            const startDate = $('#project_update_prolongation_period_form_prolongationStart').val();
            if (Number.isInteger(months) && months > 0 && startDate !== '') {
                let date = new Date(startDate);
                date.setUTCMonth(date.getUTCMonth() + months);
                date.setUTCDate(date.getUTCDate() - 1);
                if (!isNaN(date.getTime())) {
                    $('#project_update_prolongation_period_form_prolongationEnd').val(date.toISOString().substring(0, 10));
                }
            }
        }
        $('#project_update_prolongation_period_form_prolongationMonths').on('change', updateProlongationPeriodEnd);
        $('#project_update_prolongation_period_form_prolongationStart').on('change', updateProlongationPeriodEnd);
    }

	if($(".table-approved-funding").length) {
		$(document).on('change', '.table-approved-funding input[data-personal-year]', function(){
			var totalYear = 0;
			$('.table-approved-funding input[data-personal-year='+$(this).attr('data-personal-year')+']').each( function(){
				totalYear += parseFloat($(this).val());
			});
			$('.table-approved-funding th[data-personal-year='+$(this).attr('data-personal-year')+']').html(Number(totalYear).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
			
			var totalRow = 0;
			$(this).closest('tr').find('input[data-personal-year]').each( function(){
				totalRow += parseFloat($(this).val());
			});
			$(this).closest('tr').find('input[data-personal-row-total]').val(totalRow.toFixed(2));
			
			var total = 0;
			$('.table-approved-funding input[data-personal-row-total]').each( function(){
				total += parseFloat($(this).val());
			});
			$('.table-approved-funding th[data-personal-row-total]').html(Number(total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
		});
		
		$('.table-approved-funding input[data-year]').on('change', function(){
			var section = $(this).attr('data-type');
			var total = 0;
			$('.table-approved-funding input[data-type='+section+']').each( function(){
				total += parseFloat($(this).val());
			});
			$('.table-approved-funding tr[data-type='+section+'] th[data-type=total]').html(Number(total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
		});
	}
	
	
  if ($(".custom-collection-personal-funds-table-add-entry").length) {

    function addTableItem(addButton) {
		var addButtonContainerSelector = addButton.dataset.container;
		var addButtonContainer = document.querySelector(addButtonContainerSelector);
        var container = addButtonContainer.parentNode.closest('table');
        var prototype = addButtonContainer.dataset.prototype;

        var index = container.querySelectorAll('tr').length;

        var newItem = prototype.replace(/__name__/g, index);

        // Create a wrapper element for the new item
        var itemWrapper = document.createElement('tr');
        itemWrapper.innerHTML = newItem;

        addButtonContainer.insertAdjacentElement('beforebegin', itemWrapper);
        window.a11yToggle(itemWrapper);

        var addItemButtons = itemWrapper.getElementsByClassName('add-table-item');
        for (var i = 0; i < addItemButtons.length; i++) {
            addItemButtons[i].addEventListener('click', function() {
                addTableItem(this);
            });
        }

        var deleteButtons = container.querySelectorAll('.delete-table-item');
        var newDeleteButton = deleteButtons[deleteButtons.length - 1];
        newDeleteButton.addEventListener('click', function(event) {
            event.preventDefault();
            deleteTableItem(this);
        });
        
    }

    function deleteTableItem(deleteButton) {

        var item = deleteButton.parentNode.closest('tr');
        item.parentNode.removeChild(item);
    }

    var addButtons = document.getElementsByClassName('add-table-item');
    for (var i = 0; i < addButtons.length; i++) {
        addButtons[i].addEventListener('click', function() {
            addTableItem(this);
        });
    }

    var deleteButtons = document.getElementsByClassName('delete-table-item');
    for (var i = 0; i < deleteButtons.length; i++) {
        deleteButtons[i].addEventListener('click', function() {
            deleteTableItem(this);
        });
    }
  }	
	
	
    // formulari Scientific Report Form amb camps select depenents
    var enableFieldFunc = function (origin) {
        var originJQuery = $(origin);

        var destinationSelector = originJQuery.attr('data-enable-field');
        var $selectedItems = $(destinationSelector);
        $selectedItems.each(function() {
            $(this).hide();
        });
        
        var originValue = originJQuery.val();
        var $enabledItems = $(destinationSelector + '[data-state="' + originValue+ '"]');
        $enabledItems.each(function() {
            $(this).show();
        });
    }

    var $dataEnableField = $('[data-enable-field]');

    $dataEnableField.each(function () {
        var that = this;
        enableFieldFunc(that);
    });

    $dataEnableField.change(function(e) {
        enableFieldFunc(e.target);
    });	

    // formulari Scientific Report Form amb publicacions dependents
    var updateScientificReportingPublication = function (publicationEntry) {
        var publicationType = publicationEntry.querySelector('[data-manuscript-trigger-value]');
        var manuscriptType = publicationEntry.querySelector('.scientific-reporting-manuscript-type');
        var publicationDetails = publicationEntry.querySelector('.scientific-reporting-publication-details');
        var publicationRequiredFields = publicationEntry.querySelectorAll('[data-publication-required]');

        if (!publicationType || !manuscriptType || !publicationDetails) {
            return;
        }

        var publicationInPreparation = publicationType.value.toLowerCase() === publicationType.dataset.manuscriptTriggerValue.toLowerCase();

        manuscriptType.classList.toggle('is-hidden', !publicationInPreparation);
        if (!publicationInPreparation) {
            var manuscriptTypeField = manuscriptType.querySelector('select');
            if (manuscriptTypeField) {
                manuscriptTypeField.value = '';
            }
        }

        publicationDetails.classList.toggle('is-hidden', publicationInPreparation);
        publicationRequiredFields.forEach(function (field) {
            field.required = publicationType.value !== '' && !publicationInPreparation;
        });
    }

    var updateAllScientificReportingPublications = function () {
        document.querySelectorAll('.scientific-reporting-publication-entry').forEach(updateScientificReportingPublication);
    }

    $(document).on('change', '[data-manuscript-trigger-value]', function () {
        updateScientificReportingPublication(this.closest('.scientific-reporting-publication-entry'));
    });

    $(document).on('click', '.add-item[data-container^="#project_scientific_reporting_form_form_publications_"]', function () {
        window.setTimeout(updateAllScientificReportingPublications, 0);
    });

    updateAllScientificReportingPublications();
    
    
    // formulari cost calculation amb camp checkbox depenents
    var disableFieldsFuncOnChecked = function (origin) {
        var originJQuery = $(origin);

        var destinationSelector = originJQuery.attr('data-disable-fields-on-checked');
        var $selectedItems = $(destinationSelector);
        $selectedItems.each(function() {
            $(this).show();
        });
        
        // Comprova si el checkbox està marcat
        if (originJQuery.prop('checked')) {
            $selectedItems.each(function() {
                $(this).hide();
            });
        }
    }

    var $dataDisableFieldsOnChecked = $('[data-disable-fields-on-checked]');

    $dataDisableFieldsOnChecked.each(function () {
        var that = this;
        disableFieldsFuncOnChecked(that);
    });

    $dataDisableFieldsOnChecked.change(function(e) {
        disableFieldsFuncOnChecked(e.target);
    });
    
    
    // formulari solicitud follow up
    var enableFieldsFuncOnChecked = function (origin) {
        var originJQuery = $(origin);

        var destinationSelector = originJQuery.attr('data-enable-fields-on-checked');
        var $selectedItems = $(destinationSelector);
        $selectedItems.each(function() {
            $(this).hide();
        });
        
        // Comprova si el checkbox està marcat
        if (originJQuery.prop('checked')) {
            $selectedItems.each(function() {
                $(this).show();
            });
        }
    }

    var $dataEnableFieldsOnChecked = $('[data-enable-fields-on-checked]');

    $dataEnableFieldsOnChecked.each(function () {
        var that = this;
        enableFieldsFuncOnChecked(that);
    });

    $dataEnableFieldsOnChecked.change(function(e) {
        enableFieldsFuncOnChecked(e.target);
    });
    
    
    const MAX_SIZE_MB = 5; // ← Personalitzable
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
        
    $(document).on('change', '.ajaxFileUpload input[type="file"]', function () {
        const fileInput = $(this);
        const parentDiv = fileInput.closest('.ajaxFileUpload');
        const hiddenInput = parentDiv.find('input[type="hidden"]');
        const file = fileInput[0].files[0];

        // Eliminar missatges anteriors
        parentDiv.find('.upload-message').remove();

        if (!file) return;

//        // Validació de mida abans d'enviar
//        if (file.size > MAX_SIZE_BYTES) {
//            const message = `El fitxer supera la mida màxima de ${MAX_SIZE_MB} MB.`;
//            const messageDiv = $('<div class="upload-message" style="color:red;"></div>').text(message);
//            fileInput.parent().append(messageDiv);
//            return;
//        }
        
        const formData = new FormData();
        formData.append('file', file);

        $.ajax({
            url: '/document-upload',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                // Esperem JSON amb { success: true|false, message: "", id?: "" }
                const messageDiv = $('<div class="upload-message"></div>');
                if (response.success) {
                    messageDiv.addClass('has-text-success').text(response.message);
                    hiddenInput.val(response.id); // assignar ID retornat
                } else {
                    messageDiv.addClass('has-text-danger').text(response.message);
                }
                fileInput.parent().append(messageDiv);
                
                // Eliminar fitxer seleccionat
                const newFileInput = fileInput.clone().val('');
                fileInput.replaceWith(newFileInput);
            },
            error: function (xhr) {
                let errorMessage = `Error: ${xhr.status} ${xhr.statusText}`;
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage += ` - ${xhr.responseJSON.message}`;
                }
                const messageDiv = $('<div class="upload-message has-text-danger"></div>').text(errorMessage);
                fileInput.parent().append(messageDiv);
                
                // Eliminar fitxer seleccionat
                const newFileInput = fileInput.clone().val('');
                fileInput.replaceWith(newFileInput);
            }
        });
    });
    
    $(document).on('click', '.ajaxFileDelete button.delete-file', function () {
        const button = $(this);
        const parentDiv = button.closest('.ajaxFileDelete');
        const linkContainerDiv = button.closest('.documentDownload');
        const hiddenInput = parentDiv.find('input[type="hidden"]');

        hiddenInput.val(''); // desassignem document ID
        linkContainerDiv.text(""); // eliminem contingut del contenidor del link
        
        return false;
    });
});

document.addEventListener('DOMContentLoaded', () => {
  (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
    const $notification = $delete.parentNode.parentNode;

    $delete.addEventListener('click', () => {
      $notification.parentNode.removeChild($notification);
    });
  });
});

// funcionalitat password visible per camps amb id=password
document.addEventListener("DOMContentLoaded", () => {
  const passwordFields = document.querySelectorAll('input[type="password"]');

  passwordFields.forEach((field) => {
    // Evitem duplicar la funcionalitat si ja s’ha afegit
    if (field.dataset.toggleAttached === "true") return;

    // Crear el contenidor i aplicar estil relatiu
    const wrapper = document.createElement("div");
    wrapper.classList.add("password-wrapper");
    wrapper.style.position = "relative";
    wrapper.style.display = "flex";
    wrapper.style.alignItems = "center";

    // Inserir el wrapper abans i moure el camp dins
    field.parentNode.insertBefore(wrapper, field);
    wrapper.appendChild(field);

    // Crear el botó de toggle (ull)
    const toggleButton = document.createElement("span");
    toggleButton.style.position = "absolute";
    toggleButton.style.right = "20px";
    toggleButton.style.cursor = "pointer";
    toggleButton.innerHTML = eyeSVG();
    wrapper.appendChild(toggleButton);

    let visible = false;

    toggleButton.addEventListener("click", () => {
      visible = !visible;
      field.type = visible ? "text" : "password";
      toggleButton.innerHTML = visible ? eyeOffSVG() : eyeSVG();
    });

    // Marquem que ja hem afegit el toggle a aquest camp
    field.dataset.toggleAttached = "true";
  });

  function eyeSVG() {
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
</svg>`;
  }

  function eyeOffSVG() {
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
  <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
  <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
  <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
</svg>`;
  }
});



document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("ajax-form-user-search");

    if (!form) return;

    form.addEventListener("submit", function (e) {
        e.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const endpoint = form.dataset.provider;
        const containerClass = form.dataset.container;
        const container = document.querySelector("." + containerClass);

        const keywordInput = form.querySelector("#keyword");
        const keyword = keywordInput ? keywordInput.value : "";

        const url = new URL(endpoint, window.location.origin);
        url.searchParams.append("keyword", keyword);

        // ✅ Add spinner
        if (button) button.classList.add("is-loading");

        fetch(url, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
        .then(response => response.text())
        .then(html => {
            if (container) {
                container.innerHTML = html;
            }
        })
        .catch(error => {
            console.error("Error fetching users:", error);
        })
        .finally(() => {
            // ✅ Remove spinner
            if (button) button.classList.remove("is-loading");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const forms = document.querySelectorAll("[data-ajax-form-user-search]");

    forms.forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();

            const button = form.querySelector('button[type="submit"]');
            const endpoint = form.dataset.provider;
            const containerClass = form.dataset.container;
            const container = document.querySelector("." + containerClass);

            const keywordInput = form.querySelector(".keyword");
            const keyword = keywordInput ? keywordInput.value : "";

            const url = new URL(endpoint, window.location.origin);
            url.searchParams.append("keyword", keyword);

            if (button) button.classList.add("is-loading");

            fetch(url, {
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
            .then(response => response.text())
            .then(html => {
                if (container) {
                    container.innerHTML = html;
                }
            })
            .catch(error => {
                console.error("Error fetching users:", error);
            })
            .finally(() => {
                if (button) button.classList.remove("is-loading");
            });
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".button-loading-behaviour");
        if (!btn) return;

        // Avoid double clicks
        if (btn.classList.contains("is-loading")) {
            e.preventDefault();
            return;
        }

        // Add Bulma spinner
        btn.classList.add("is-loading");

        // Optional: prevent further interaction
        btn.style.pointerEvents = "none";

        // Special case: <a> links (navigation)
        if (btn.tagName === "A") {
            // Let navigation continue naturally
            return;
        }

        // Special case: <button type="submit">
        if (btn.tagName === "BUTTON") {
            const form = btn.closest("form");
            if (form && btn.type === "submit") {
                // Let form submit naturally
                return;
            }
        }
    });

});
